import { createSlice } from '@reduxjs/toolkit'

export const sidebarUI = createSlice({
  name: 'sidebarUI',
  initialState: {
    openCalendar: false,
    openAnnouncements: false,
  },
  reducers: {
    toggleCalendar: (state) => {
      state.openCalendar = !state.openCalendar
    },
    toggleAnnouncements: (state) => {
      state.openAnnouncements = !state.openAnnouncements
    },
  },
})

export const { toggleCalendar, toggleAnnouncements } = sidebarUI.actions

export default sidebarUI.reducer
